import React from "react";
import { makeStyles, Button, Dialog, InputLabel, DialogContent, Slide, Typography } from "@material-ui/core";
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import File from '../components/formikcomponent/Imageinput';
import { string, number, mixed, object } from 'yup';
import { Formik, Field, Form } from "formik";
import FormikTextField from "../components/formikcomponent/TextField";
const axios = require("axios").default;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function AlertDialogSlide(props) {
  const [category, setCategory] = React.useState();
  const [erroropen, setErrorOpen] = React.useState(false);
  const [categoryname, setCategoryName] = React.useState({
    categoryid: 0,
    title: "",
    displayorder: 0,
    categoryImage: [],
  });
  const [editcategoryid, setEditCategoryId] = React.useState(false);
  const ERR_MESSAGE = "This field is required.";
  const validateWithSchema = object().shape({
    categoryid: number().required(ERR_MESSAGE),
    title: string().required(ERR_MESSAGE),
    displayorder: number().required(ERR_MESSAGE),
    categoryImage: mixed().required(ERR_MESSAGE),
  });

  React.useEffect(() => {
    async function getUsercategory() {
      try {
        const response = await axios.get(
          `/api/resourceContentManagement/getArticleCategory`
        );

        setCategory(response.data.data);
      } catch (error) {
        console.error(error);
      }
    }
    getUsercategory();


    if (props.editcategorydata !== void (0)) {
      setEditCategoryId(true);
      categoryname.categoryid = props.editcategorydata[0].categoryId;
      categoryname.displayorder = props.editcategorydata[0].displayOrder;
      categoryname.title = props.editcategorydata[0].title;
      categoryname.categoryImage = props.editcategorydata[0].categoryImage;
      setCategoryName({ ...categoryname });
    }
  }, []);

  React.useEffect(() => {
    const sortcategory = () => {
      if (category) {
        return category.sort((a, b) => a.categoryId - b.categoryId);
      }
    };
    if (category && !(editcategoryid)) {
      const value = sortcategory().filter((val, i) => {
        if (i === category.length - 1) {
          return val;
        }
      });
      if (value.length > 0) {
        categoryname.categoryid = value[0].categoryId + 1;
        categoryname.displayorder = value[0].categoryId + 1;
      } else {
        categoryname.categoryid = 1;
        categoryname.displayorder = 1;
      }
    }
    setCategoryName({ ...categoryname });
  }, [category]);
  const COLOR = "rgb(243, 244, 245)";
  const useStyles = makeStyles((theme) => ({
    formControl: { margin: theme.spacing(1), minWidth: 120, },
    selectEmpty: { marginTop: theme.spacing(2), },
    errormessage: { color: "#f44336", fontSize: " 0.75rem", paddingTop: "3px" }, paddingBottom: { paddingBottom: "10px", paddingTop: "10px" },
    button: {
      height: "40px",
      margin: "20px 0",
      marginRight: "30px",
      marginLeft: "10px",
      backgroundColor: "#2262bf",
      textColor: "#fff",
      color: "white",
      paddingRight: "26px",
      paddingLeft: "13px",
      fontSize: "13.7px",
      whiteSpace: "nowrap",
      cursor: "pointer",
      borderRadius: "50px",
      [theme.breakpoints.down("sm")]: {
        fontSize: '12px',
        minWidth: "120px"
      },
      '&:hover': {
        backgroundColor: "green",
        color: '#FFF'
      }
    }, holder: { backgroundColor: 'white', paddingTop: '10px', },
    main: { maxWidth: '450px', margin: 'auto' },
    button2: { marginLeft: "9rem" },
    viewButtonLabel: { paddingLeft: "10px" },
    root: { paddingLeft: "20px", backgroundColor: COLOR, paddingRight: "20px" },
  }));

  const classes = useStyles();
  return (
    <div >
      <Dialog
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        maxWidth={"sm"}
        PaperProps={{ style: { backgroundColor: COLOR, boxShadow: "none" }, }}
      >
        <DialogContent>
          <Formik
            enableReinitialize={true}
            validator={() => ({})}
            validationSchema={validateWithSchema}
            initialValues={categoryname}
            onSubmit={(values, actions) => {
              if (typeof (values.categoryImage) === "string") {
                if (editcategoryid) {
                  axios({ method: "put", url: `/api/resourceContentManagement/updateArticleCategory/${values.categoryid}`, data: values});
                } else {
                  axios({ method: "post", url: "/api/resourceContentManagement/articleCategory", data: values});
                }
              } else {
                let resdata = [];
                const image = values.categoryImage;
                const data = new FormData();

                data.append(`categoryfile`, image, values.categoryid);
                axios({ method: "post", url: "/api/resourceContentManagement/articleCategoryFileUpload ", data: data, headers: { "Content-Type": "multipart/form-data", "Content-Length": values.size, } })
                  .then(function (response) {
                    response.data.result.map((res) => {
                      return resdata.push(res.Location);
                    });
                    values.categoryImage = resdata[0];
                    actions.setValues({ ...values });
                    if (editcategoryid) {
                      axios({ method: "put", url: `/api/resourceContentManagement/updateArticleCategory/${values.categoryid}`, data: values});
                    }
                    else {
                      axios({ method: "post", url: "/api/resourceContentManagement/articleCategory", data: values});
                    }
                  });
              }
              setTimeout(() => {
                alert(JSON.stringify(values, null, 2));
                actions.setSubmitting(false);
              }, 1000);
            }}
          >
            {({
              values,
              handleChange,
              isSubmitting = true,
              validateForm,
              errors,
              touched,
              formik,
              setFieldValue,
            }) => (
                <Form className={classes.root}>
                  <Typography variant="h5" component="h5">
                    Category
                        </Typography>
                  <br />
                  <div className={classes.main}>
                    <div className={classes.holder}>
                      <GridContainer>


                        <GridItem md={8} lg={8} sm={12} xs={12} className={classes.paddingBottom}>
                          <InputLabel>Category Title</InputLabel>
                          <Field
                            name={"title"}
                            type="text"
                            component={FormikTextField}
                            variant="filled"
                            onChange={handleChange}
                          />
                          {erroropen ? (
                            <InputLabel style={{ color: "red" }}>
                              Catetory Title already exit
                            </InputLabel>
                          ) : (
                              ""
                            )}

                        </GridItem>
                        <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom} style={{ marginBottom: "20px" }}>
                          <InputLabel>Image</InputLabel>
                          <Field
                            name={"categoryImage"}
                            // type="file"
                            component={File}
                            variant="filled"
                            onChange={handleChange}
                            editcategoryid={editcategoryid}
                          />{errors.content && touched.content && errors.content.categoryImage && touched.content.categoryImage ? <p className={classes.errormessage}>{errors.content.categoryImage}</p> : ""}
                        </GridItem>

                        <GridItem md={12} lg={12} sm={12} xs={12} style={{ backgroundColor: COLOR, paddingTop: "10px", paddingBottom: "10px" }}></GridItem >
                        <GridItem md={12} lg={12} sm={12} xs={12} >
                          <Button
                            classes={{ label: classes.viewButtonLabel }}
                            autoFocus
                            onClick={props.handleClose}
                            className={classes.button}
                          >
                            {"Cancel   "}
                          </Button>
                          <Button
                            variant="contained"
                            onClick={() =>
                              validateForm().then((arg) => {
                               // console.log(arg);
                              })
                            }
                            type="submit"
                            disabled={isSubmitting}
                            classes={{ label: classes.viewButtonLabel }}

                            className={classes.button + " " + classes.button2}
                          >
                            Submit
                              </Button>
                        </GridItem>
                        <GridItem md={12} lg={12} sm={12} xs={12} style={{ backgroundColor: COLOR, paddingTop: "10px", paddingBottom: "10px" }}></GridItem >
                      </GridContainer></div></div>
                </Form>
              )}
          </Formik>
        </DialogContent>

      </Dialog>
    </div>
  );
}
